/*
 * (c) copyright 2021 International Road Dynamics Inc. and related companies.
 * All rights reserved.
 * Copyright as an unpublished work.
 *
 * This file contains confidential information of International
 * Road Dynamics Inc. and related companies, and should be treated as proprietary
 * and confidential.
 *
 * The use, copying, disclosure or modification of the
 * programs and/or source code is prohibited unless
 * otherwise provided for in the license or confidentiality
 * agreements.
 *
 * Any copy must contain this copyright notice.
 */

import React from 'react'
import PropTypes from 'prop-types'

import { makeStyles } from '@material-ui/core/styles'
import AppBar from '@material-ui/core/AppBar'
import Link from '@material-ui/core/Link'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'

const useStyles = makeStyles((theme) => ({
  root: {
    color: 'black',
    backgroundColor: '#e5e5e5',
    boxShadow: 'none'
  },
  logo: {
    height: '48px',
    width: 'auto',
    'padding-right': '1em'
  },
  title: {
    flexGrow: 1
  },
  login: {
    cursor: 'pointer'
  }
}))

function PageHeader (props) {
  const classes = useStyles()

  return (
    <div>
      <AppBar
        position="static"
        classes={{
          root: classes.root
        }}
      >
        <Toolbar>
          <img src="/img/logos/vi2m_logo.png" className={classes.logo} />

          <Typography variant="h6" className={classes.title}>
            Hawaii Traffic Data Map
          </Typography>

          <Link
            className={classes.login}
            color="inherit"
            href={props.vi2mLoginUrl}
            target="_blank"
            underline="none"
          >
            VI<sup>2</sup>M Login
          </Link>
        </Toolbar>
      </AppBar>
    </div>
  )
}

PageHeader.propTypes = {
  vi2mLoginUrl: PropTypes.string
}

export default PageHeader
